const initialState = { arr: [{id_eleve: '', nom: '', prenom: '', niveau: '', id_classe: ''}] }

export default function eleveReducer(state = initialState, action) {
  switch (action.type) {
    case 'user/eleveDetail': {
      // Can return just the new todos array - no extra object around it
      return {
        ...state,
        arr: action.payload,
      }
    }
    default:
      return state
  }
}